'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportModal = require('../actions/report-modal');

var INITIAL_STATE = {
    isOpen: false,
    reportText: '',
    reportEmail: '',
    submitted: false,
    accepted: false,
    model: {}
};

var reportModal = function reportModal(state, action) {
    switch (action.type) {
        case _reportModal.CLOSE_REPORT_MODAL:
            return Object.assign({}, state, INITIAL_STATE);
        case _reportModal.OPEN_REPORT_MODAL:
            return Object.assign({}, state, { isOpen: true, model: action.payload });

        case _reportModal.CHANGE_TEXT_REPORT_MODAL:
            return Object.assign({}, state, action.payload);
        case _reportModal.CHANGE_EMAIL_REPORT_MODAL:
            return Object.assign({}, state, action.payload);
        case _reportModal.INVALID_FORM_REPORT_MODAL:
            return Object.assign({}, state, { submitted: true });

        case _reportModal.SEND_REPORT_MODAL + '_REQUESTED':
            return Object.assign({}, state, {});
        case _reportModal.SEND_REPORT_MODAL + '_RECEIVED':
            return Object.assign({}, state, { accepted: true });
        case _reportModal.SEND_REPORT_MODAL + '_FAILED':
            return Object.assign({}, state, {});
        default:
            return state || INITIAL_STATE;
    }
};

exports.default = reportModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/report-modal.js
// module id = 1689
// module chunks = 0